/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss warning`)
};

const es_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar advertencia`)
};

const de_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnung schließen`)
};

const nl_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarschuwing sluiten`)
};

const fr_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer l’avertissement`)
};

const it_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora avviso`)
};

const pt_br2_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispensar aviso`)
};

const pt_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar aviso`)
};

const ja_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`警告を閉じる`)
};

const zh_common_dismiss_warning = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭警告`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const common_dismiss_warning = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_dismiss_warning(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("common_dismiss_warning", locale)
	if (locale === "en") return en_common_dismiss_warning(inputs)
	if (locale === "es") return es_common_dismiss_warning(inputs)
	if (locale === "de") return de_common_dismiss_warning(inputs)
	if (locale === "nl") return nl_common_dismiss_warning(inputs)
	if (locale === "fr") return fr_common_dismiss_warning(inputs)
	if (locale === "it") return it_common_dismiss_warning(inputs)
	if (locale === "pt-BR") return pt_br2_common_dismiss_warning(inputs)
	if (locale === "pt") return pt_common_dismiss_warning(inputs)
	if (locale === "ja") return ja_common_dismiss_warning(inputs)
	return zh_common_dismiss_warning(inputs)
};